import Vue from 'vue'
import Vuex from 'vuex'

import addressProvince from './modules/address.province'
import article from './modules/article'
import auth from './modules/auth'
import authPartner from './modules/auth.partner'
import bankTransfer from './modules/bank.transfer'
import booking from './modules/booking'
import business from './modules/business'
import chatBooking from './modules/chat.booking'
import companyAddress from './modules/company.address'
import credit from './modules/credit'
import discount from './modules/discount'
import email from './modules/email'
import experience from './modules/experience'
import extras from './modules/extras'
import globalVal from './modules/global.val'
import inbox from './modules/inbox'
import jobPost from './modules/job.post'
import jobUser from './modules/job.user'
import listing from './modules/listing'
import message from './modules/message'
import notification from './modules/notification'
import order from './modules/order'
import orderDetail from './modules/order.detail'
import partner from './modules/partner'
import payment from './modules/payment'
import phoneVerification from './modules/phone.verification'
import preBooking from './modules/pre.booking'
import professional from './modules/professional'
import professionalCalendar from './modules/professional.calendar'
import professionalPhotos from './modules/professional.photos'
import professionalRegister from './modules/professional.register'
import professionalReviews from './modules/professional.reviews'
import promoCode from './modules/promo.code'
import promotion from './modules/promotion'
import receivedOrder from './modules/received.order'
import referralCode from './modules/referral.code'
import referralUser from './modules/referral.user'
import review from './modules/review'
import reportIssue from './modules/report.issue'
import reward from './modules/reward'
import scb from './modules/scb'
import service from './modules/service'
import serviceRequest from './modules/service.request'
import socialCampaign from './modules/social.campaign'
import subscription from './modules/subscription'
import user from './modules/user'
import userSetting from './modules/user.setting'
import userPersonalTopic from './modules/user.personal.topic'
import userPoint from './modules/user.point'
import userReward from './modules/user.reward'
import ServiceTeam from './modules/service.team'
import createPersistedState from 'vuex-persistedstate'

let plugins = [createPersistedState()]

Vue.use(Vuex)
// const debug = process.env.NODE_ENV !== 'production'
// Vue.config.debug = debug
// Vue.config.warnExpressionErrors = true

const vuexStoreConfig = {
  modules: {
    addressProvince,
    article,
    auth,
    authPartner,
    bankTransfer,
    booking,
    business,
    chatBooking,
    companyAddress,
    credit,
    discount,
    email,
    experience,
    extras,
    globalVal,
    inbox,
    jobPost,
    jobUser,
    listing,
    message,
    notification,
    order,
    orderDetail,
    partner,
    payment,
    phoneVerification,
    preBooking,
    professional,
    professionalCalendar,
    professionalPhotos,
    professionalRegister,
    professionalReviews,
    promoCode,
    promotion,
    receivedOrder,
    referralCode,
    referralUser,
    review,
    reportIssue,
    reward,
    scb,
    service,
    serviceRequest,
    socialCampaign,
    subscription,
    user,
    userSetting,
    userPersonalTopic,
    userPoint,
    userReward,
    ServiceTeam
  },
  plugins
}

export default new Vuex.Store(vuexStoreConfig)



// WEBPACK FOOTER //
// ./src/store/store.js